import React from 'react';

const Footer = () => {
    const date = new Date()
    const year = date.getFullYear()
    return (
        <footer className="footer footer-center p-4">
            <div>
                <p>Copyright © {year} - All right reserved. Mahabubul Islam</p>
            </div>
        </footer>

    );
};

export default Footer;